export { default as component } from "../../../../src/routes/[prefix]/(feature)/activity-plan/[id]/+page.svelte";